<template>
<div style="width: 100%">
	<v-container grid-list-md>
		<v-subheader>
			{{$t('templates.doc_templates')}} > {{$t('templates.template')}} #{{ $route.params.templateId }}
		</v-subheader>
		<v-layout row>
			<v-flex sm6 md6>
				<v-tooltip bottom="">
					<v-btn
						slot="activator"
						fab
						color="primary"
						@click="save"
					>
						<v-icon>save</v-icon>
					</v-btn>
					<span>{{$t('templates.save_changes')}}</span>
				</v-tooltip>

				<v-tooltip bottom="" v-if="env == 'development'">
					<v-btn
						slot="activator"
						:loading="isLoadDownloadLoadLink"
						fab
						color="primary"
						@click="download"
					>
						<v-icon>cloud_download</v-icon>
					</v-btn>
					<span>{{$t('templates.download_prev')}}</span>
				</v-tooltip>

				<v-tooltip bottom="">
					<v-btn
						slot="activator"
						fab
						color="primary"
						@click="downloadOriginalTemplate"
					>
						<v-icon>cloud_download</v-icon>
					</v-btn>
					<span>{{$t('templates.download_original')}}</span>
				</v-tooltip>

				<a ref="linkDownload"
					style="visibility: hidden"
					:href="downloadLink"
					@click="clearDownloadLink"
					v-if="env == 'development'"
				>
					{{$t('templates.download_file')}}
				</a>
				<a ref="linkDownloadOriginal"
					style="visibility: hidden"
					:href="originalLink"
				>
					{{$t('templates.download_file')}}
				</a>
			</v-flex>
			<v-flex sm6 md6>
				<v-text-field :label="$t('common.template_name')"
					v-model="template.template_name"
				/>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs6>
				<v-subheader> {{$t('templates.available_fields')}} </v-subheader>
				<v-card dark height="530px">
					<v-card-text>
						<codemirror v-model="fields" :options="cmOptions" />
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs6>
				<v-subheader>{{$t('templates.config')}}</v-subheader>
				<v-card light color="white" height="530px">
					<v-card-text>
						<codemirror v-model="config" :options="cmOptions" />
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</div>
</template>

<script>
import Vue from 'vue'
import { createNamespacedHelpers } from 'vuex'
import { notify } from '../utils/notifications'

const { mapActions, mapState } = createNamespacedHelpers('templates')

export default {
	data: vm => ({
		fields: vm.$t('templates.loading'),
		config: vm.$t('templates.loading'),
		cmOptions: {
			// codemirror options
			tabSize: 4,
			mode: 'application/json',
			theme: 'base16-dark',
			lineNumbers: true,
			line: true
			// more codemirror options, 更多 codemirror 的高级配置...
		}
	}),
	watch: {
		list() {
			this.fields = JSON.stringify(this.template.fields, null, 2)
			this.config = JSON.stringify(this.template.config || {}, null, 2)
		}
	},
	methods: {
		...mapActions(['fetch', 'saveTemplate', 'downloadPreview', 'clearLink']),
		save() {
			this.saveTemplate({
				template: this.config,
				template_name: this.template.template_name
			})
			.then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.saved', {
						type: this.$t('templates.template')
					})
				})
			})
		},
		download() {
			this.downloadPreview().then(() => {
				this.$refs.linkDownload.click()
			})
		},
		downloadOriginalTemplate() {
			this.$refs.linkDownloadOriginal.click()
		},
		clearDownloadLink() {
			setTimeout(() => {
				this.clearLink()
			}, 1500)
		}
	},
	computed: {
		...mapState(['list', 'downloadLink', 'isLoadDownloadLoadLink']),
		template() {
			let id = this.$route.params.templateId
			return this.list.find(element => element.id == id) || {}
		},
		env() {
			return process.env.NODE_ENV
		},
		originalLink() {
			return Vue.http.options.root + '/files/' + this.template.filename
		}
	},
	created() {
		this.fetch()
	}
}
</script>

<style>
.CodeMirror {
	border: 1px solid #eee;
	height: 500px;
}
</style>
